const flex1 = { flex: 1 }

export default function Spacer() {
  return <div style={flex1}></div>
}